import api from '../../api'

export default {
  props: {
    token: {
      default: ''
    }
  },
  name: 'RestorePassword',
  data: () => {
    return {
      email: '',
      password: '',
      password2: ''
    }
  },
  computed: {
    isInvalid () {
      return Object.values(this.fields).some(x => !x.valid)
    }
  },
  methods: {
    restorePassword () {
      if (this.isInvalid) return
      const passInfo = {
        password: this.password,
        password2: this.password2
      }
      api.post.restorePassword(this.token, passInfo)
        .then(() => {
          this.$router.push('/login')
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    }
  },
  created () {
    api.get.userFromResetPassword(this.token)
      .then((response) => {
        this.email = response.data.data.username
      })
      .catch(() => this.$router.push('/login'))
  }
}
